var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { id: "exam", "min-width": "256", elevation: "5" } },
    [
      _c("v-card-title", { staticClass: "headline" }, [
        _c("h6", { staticStyle: { color: "#f78129" } }, [
          _vm._v(_vm._s(_vm.exam.codigoCompra))
        ])
      ]),
      _c(
        "v-card-subtitle",
        {
          staticClass: "pb-1",
          staticStyle: { "font-weight": "bold", "font-size": "0.65rem" }
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm._f("toUpperCase")(_vm.exam.status)) +
              " - " +
              _vm._s(_vm.switchDate(_vm.exam.codigoStatus)) +
              " "
          )
        ]
      ),
      _c(
        "v-card-text",
        { staticClass: "pb-0" },
        [
          _c(
            "v-row",
            { staticClass: "px-3 pt-5" },
            [
              _c("span", { staticClass: "payment" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("formatMode")(_vm.exam.paymentForm)) + " "
                )
              ]),
              _c("v-spacer"),
              _c("span", { staticClass: "payment" }, [
                _vm._v(" R$" + _vm._s(_vm.exam.examValue) + " ")
              ])
            ],
            1
          ),
          _c("v-divider", { staticClass: "mt-6 mb-2" }),
          _vm.exam.codigoStatus != 6
            ? _c("div", { staticClass: "d-flex px-1 pb-1" }, [
                _c("p", [
                  _vm._v(
                    " Sua NOTA FISCAL ficará disponivel até 24h úteis após o resultado do seu exame ser disponibilizado "
                  )
                ])
              ])
            : _vm._e(),
          _vm.exam.codigoStatus == 6
            ? _c(
                "div",
                { staticClass: "d-flex px-1 pb-3" },
                [
                  _c("span", [_vm._v(" NOTA FISCAL ")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { icon: "", href: _vm.receipt.linkNfe } },
                    [
                      _c("v-icon", { attrs: { large: "" } }, [
                        _vm._v("mdi-printer")
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-3",
                      attrs: { icon: "" },
                      on: { click: _vm.share }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mx-3", attrs: { large: "" } },
                        [_vm._v("mdi-share")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }